import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { PACIMPgpWithProvider } from '@core/model';
import { ProviderAccountDTO, TableColumn } from '@mynexus/mynexus-ui-lib';
import { SortMeta } from 'primeng/api';
import { Table } from 'primeng/table';

export interface ProviderAccountDTOWithAddress extends ProviderAccountDTO {
  providerAddress?: string,
  providerStreetWithotNumbers?: string
};
@Component({
    selector: 'servicing-facility-select',
    templateUrl: './servicing-facility-select.component.html',
    styleUrls: ['./servicing-facility-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class ServicingFacilitySelectComponent implements OnChanges, OnInit {
  @ViewChild(Table) dt: Table;

  @Input() facilities: PACIMPgpWithProvider[] = [];
  @Input() isExternal!: boolean;
  @Output() selected = new EventEmitter<number>();

  cols: TableColumn[];
  tableData!: ProviderAccountDTOWithAddress[];
  multiSortMeta: SortMeta[] = [];
  searchInput: string;

  ngOnChanges(): void {
    if (this.isExternal) {
      this.tableData = this.facilities.map(provider => {
        const address = `${provider.physicalStreet}, ${provider.physicalCity} ${provider.physicalState} ${provider.physicalZip}`;

        return {
          ...provider,
          providerAddress: address,
          providerStreetWithotNumbers: provider.physicalStreet.replace(/[0-9]/g, '')
        }
      })?.sort((a, b) => a?.outOfMembersNetwork > b?.outOfMembersNetwork ? 1 : -1);
    } else {
      this.tableData = this.facilities?.sort((a, b) => a?.outOfMembersNetwork > b?.outOfMembersNetwork ? 1 : -1);
    }
  }

  ngOnInit(): void {
    this.cols = [
      new TableColumn('Servicing Facility Name', 'providerName'),
      new TableColumn('Address', 'providerAddress'),
      new TableColumn('Address', 'providerStreetWithotNumbers'),
      new TableColumn('Phone', 'locationPhone'),
      new TableColumn('Fax', 'locationFax'),
      new TableColumn('Fax Confirmed', 'locationFaxConfirmed'),
      new TableColumn('In-Network for Member', 'outOfMembersNetwork')
    ] as Array<TableColumn>;

    this.multiSortMeta = this.isExternal
      ? [{field: 'providerName', order: 1}, {field: 'providerStreetWithotNumbers', order: 1}]
      : null;
  }

  selectProvider(data: PACIMPgpWithProvider): void {
    const selectedFacilityIndex = this.facilities.findIndex((facility: PACIMPgpWithProvider) => {
      return facility.providerAccountId === data.providerAccountId && facility.providerPgpId === data.providerPgpId
    });

    this.selected.emit(selectedFacilityIndex);
  }

  tableFiltering(): void {
    this.dt.filterGlobal(this.searchInput, 'contains');
  }
}
